export const Gift = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16 7.5C16 5.567 17.567 4 19.5 4C21.433 4 23 5.567 23 7.5C23 9.433 21.433 11 19.5 11H16V7.5Z" stroke="currentColor" stroke-width="2"/>
<path d="M16 7.5C16 5.567 14.433 4 12.5 4C10.567 4 9 5.567 9 7.5C9 9.433 10.567 11 12.5 11H16V7.5Z" stroke="currentColor" stroke-width="2"/>
<rect x="5" y="11" width="22" height="6" rx="1" stroke="currentColor" stroke-width="2"/>
<rect x="7" y="17" width="18" height="12" rx="1" stroke="currentColor" stroke-width="2"/>
<path d="M16 11V29" stroke="currentColor" stroke-width="2"/>
</svg>`;
